"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_custom_scrollbars_1 = require("react-custom-scrollbars");
var dayjs_1 = __importDefault(require("dayjs"));
var comment_icon_svg_1 = __importDefault(require("res/img/comment-icon.svg"));
var down_chevron_grey_svg_1 = __importDefault(require("res/img/down-chevron-grey.svg"));
var up_chevron_grey_svg_1 = __importDefault(require("res/img/up-chevron-grey.svg"));
var QueryComments = function (_a) {
    var visible = _a.visible, comments = _a.comments, onToggleVisibility = _a.onToggleVisibility;
    var scrollBarRef = react_1.useRef(null);
    react_1.useEffect(function () {
        if (visible === true) {
            scrollBarRef.current.scrollToBottom();
        }
    }, [visible]);
    return (react_1.default.createElement("div", { className: "query-comments", "data-visible": visible },
        react_1.default.createElement("button", { type: "button", title: "Comments", className: "query-comments__toggle flex flex-row", onClick: onToggleVisibility },
            react_1.default.createElement("img", { src: comment_icon_svg_1.default, alt: "Comments" }),
            react_1.default.createElement("span", null, "Comments"),
            react_1.default.createElement("img", { src: visible ? down_chevron_grey_svg_1.default : up_chevron_grey_svg_1.default, alt: "Expand" })),
        react_1.default.createElement("div", { className: "query-comments__container flex flex-column" },
            react_1.default.createElement("div", { className: "query-comments__list" },
                react_1.default.createElement(react_custom_scrollbars_1.Scrollbars, { ref: scrollBarRef }, comments.map(function (comment) { return (react_1.default.createElement("div", { className: "comment", key: comment.id },
                    react_1.default.createElement("span", { className: "comment__author" }, comment.createdBy.fullName),
                    react_1.default.createElement("span", { className: "comment__date" }, dayjs_1.default(comment.createdAt).format("DD/MM/YYYY @ hh:mm:ss")),
                    react_1.default.createElement("p", null, comment.comment))); }))))));
};
exports.default = QueryComments;
